import React from 'react'
import useSearch from '../../../context/search/useSearch';
import { Interweave } from 'interweave';

interface ISearchResultsTrendingComponent {
  dataSet: DOMStringMap
}

const SearchResultsTrending: React.FC<ISearchResultsTrendingComponent> = ({ dataSet }): JSX.Element => {

  const {
    langTitleSearches,
    listSearches,
    langTitleCollections,
    listCollections,
    langTitleProducts,
    listProducts
  } = dataSet

  const {
    quickSearchResultsSuggestions,
    quickSearchResultsPages,
    quickSearchResultsArticles,
    quickSearchResultsCollections,
    quickSearchResultsProducts,
    quickSearchResultsPopularSearches,
    quickSearchResultsTrendingProducts,
  } = useSearch()


  // Show trending/popular data when there's no search term and we have data
  // Check if we have trending data and no active search results (which would indicate no search term was used)
  const hasActiveSearchResults = (quickSearchResultsSuggestions && quickSearchResultsSuggestions.length > 0) ||
    (quickSearchResultsPages && quickSearchResultsPages.length > 0) ||
    (quickSearchResultsArticles && quickSearchResultsArticles.length > 0) ||
    (quickSearchResultsCollections && quickSearchResultsCollections.length > 0) ||
    (quickSearchResultsProducts && quickSearchResultsProducts.length > 0)

  const hasTrendingData = quickSearchResultsPopularSearches?.length > 0 || quickSearchResultsTrendingProducts?.length > 0

  let showSearches = true;
  let showCollections = true;
  let showProducts = true;

  if ((quickSearchResultsSuggestions && quickSearchResultsSuggestions.length) ||
  (quickSearchResultsPages && quickSearchResultsPages.length) ||
  (quickSearchResultsArticles && quickSearchResultsArticles.length) ||
  (quickSearchResultsCollections && quickSearchResultsCollections.length)) {
    showSearches = false;
  }

  if (quickSearchResultsProducts && quickSearchResultsProducts.length) {
    showCollections = false;
    showProducts = false;
  }

  // If we have trending data and no active search results, show the dynamic trending content
  if (!hasActiveSearchResults && hasTrendingData) {
    return (
      <>
        {quickSearchResultsPopularSearches?.length > 0 && (
          <div className='search__results search__results--list search__results--trending search__results--loaded'>
            <h4 className={'search__results-title search__results-title--trending subheading'}>Popular Searches</h4>
            <div className={'search__results-list search__results-list--trending'}>
              {quickSearchResultsPopularSearches.map((search, index) => (
                <a key={index} href={`/search?q=${encodeURIComponent(search.q)}`} className="search__results-item">
                  {search.q}
                </a>
              ))}
            </div>
          </div>
        )}
        {quickSearchResultsTrendingProducts?.length > 0 && (
          <div className='search__results search__results--grid search__results--products search__results--loaded'>
            <h4 className={'search__results-title search__results-title--products subheading'}>Trending Products</h4>
            <div className={'search__results-grid search__results-grid--products'}>
              {quickSearchResultsTrendingProducts.map((product, index) => (
                <a key={index} href={product.link} className="search__results-item search__results-item--product">
                  {product.image && (
                    <img src={product.image} alt={product.title} className="search__results-item-image" />
                  )}
                  <div className="search__results-item-content">
                    <h5 className="search__results-item-title">{product.title}</h5>
                    {product.price && (
                      <span className="search__results-item-price">£{product.price}</span>
                    )}
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <>
      {
        showSearches && listSearches ? (
          <div className='search__results search__results--list search__results--trending search__results--loaded'>
            <h4 className={'search__results-title search__results-title--trending subheading'}>{langTitleSearches}</h4>
            <div className={'search__results-list search__results-list--trending'}>
              <Interweave content={listSearches} noWrap={true} />
            </div>
          </div>
        ) : null
      }
      {
        showCollections && listCollections ? (
          <div className='search__results search__results--grid search__results--collections search__results--loaded'>
            <h4 className={'search__results-title search__results-title--collections subheading'}>{langTitleCollections}</h4>
            <div className={'search__results-grid search__results-grid--collections'}>
              <Interweave content={listCollections} noWrap={true} />
            </div>
          </div>
        ) : null
      }
      {
        showProducts && listProducts ? (
          <div className='search__results search__results--grid search__results--products search__results--loaded'>
            <h4 className={'search__results-title search__results-title--products subheading'}>{langTitleProducts}</h4>
            <div className={'search__results-grid search__results-grid--products'}>
              <Interweave content={listProducts} noWrap={true} />
            </div>
          </div>
        ) : null
      }
    </>
  )
}

export default SearchResultsTrending